// extracted by mini-css-extract-plugin
export default {"content":"Z_fN","text":"Z_c2","closeButton":"Z_fP"};